import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const RolesManagement = () => {
    
    const [showNewRoleModal, setShowNewRoleModal] = useState(false);
    const [showEditRoleModal, setShowEditRoleModal] = useState(false);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [showEditUserRoleModal, setShowEditUserRoleModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedType, setSelectedType] = useState(''); 
    
    const [activeRoles, setActiveRoles] = useState({
        'Dashboard': false,
        'Referee Management': false,
        'Club Management': false,
        'Game Matchmaking': false,
        'Finances & Payouts': false,
        'Roles Management': false,
        'Notifications': false,
        'Settings': false,
        'Profile': false
    });

    const table1 = useRef(null);
    const table2 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12;

        if (table1.current && !$.fn.DataTable.isDataTable('#table1')) {
            table11 = $(table1.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current && !$.fn.DataTable.isDataTable('#table2')) {
            table12 = $(table2.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
        };
    }, []);

    // Modal functions
    const openNewRoleModal = () => setShowNewRoleModal(true);
    const closeNewRoleModal = () => setShowNewRoleModal(false);

    const openEditRoleModal = (role) => {
        setSelectedItem(role);
        setShowEditRoleModal(true);
    };
    const closeEditRoleModal = () => {
        setShowEditRoleModal(false);
        setSelectedItem(null);
    };

    const openInviteUserModal = () => setShowInviteUserModal(true);
    const closeInviteUserModal = () => setShowInviteUserModal(false);

    const openEditUserRoleModal = (user) => {
        setSelectedItem(user);
        setShowEditUserRoleModal(true);
    };
    const closeEditUserRoleModal = () => {
        setShowEditUserRoleModal(false);
        setSelectedItem(null);
    };

    const openDeleteModal = (item, type) => {
        setSelectedItem(item);
        setSelectedType(type);
        setShowDeleteModal(true);
    };
    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedItem(null);
    };

    const openBlockModal = (user) => {
        setSelectedItem(user);
        setShowBlockModal(true);
    };
    const closeBlockModal = () => {
        setShowBlockModal(false);
        setSelectedItem(null);
    };

    const confirmDelete = () => {
        alert(`${selectedType === 'role' ? 'Role' : 'User'} deleted successfully!`);
        closeDeleteModal();
    };

    const confirmBlock = () => {
        alert(`User blocked successfully!`);
        closeBlockModal();
    };

    const saveRole = () => {
        alert('Role saved successfully!');
        closeNewRoleModal();
    };

    const updateRole = () => {
        alert('Role updated successfully!');
        closeEditRoleModal();
    };

    const sendInvite = () => {
        alert('Invitation sent successfully!');
        closeInviteUserModal();
    };

    const updateUser = () => {
        alert('User updated successfully!');
        closeEditUserRoleModal();
    };
    
    const handleLinkClick = (e, callback) => {
        e.preventDefault();
        if (callback) callback();
    };
    
    // Toggle role function
    const toggleRole = (title) => {
        setActiveRoles(prev => ({
            ...prev,
            [title]: !prev[title]
        }));
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Roles Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Roles & Users</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            {/* Tabs navigation */}
                            <ul className="nav nav-tabs mb-3" id="rolesUsersTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="roles-tab" data-bs-toggle="tab" data-bs-target="#rolesView" type="button" role="tab" aria-controls="rolesView" aria-selected="true">Roles</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="users-tab" data-bs-toggle="tab" data-bs-target="#usersView" type="button" role="tab" aria-controls="usersView" aria-selected="false">Users</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="rolesUsersTabContent">
                                <div className="tab-pane fade show active" id="rolesView" role="tabpanel" aria-labelledby="roles-tab">
                                    <div className="entries-wrapper mb-3 home-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <button type="button" className="btn btn-primary create-btn" onClick={openNewRoleModal}><i className="bx bx-plus me-2" />Create</button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered" id="table1" ref={table1}>
                                            <thead>
                                                <tr>
                                                    <th>Role Name</th>
                                                    <th>Primary Responsibility</th>
                                                    <th>Access Level</th>
                                                    <th>User Count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Super Admin</td>
                                                    <td>Full platform oversight</td>
                                                    <td><span className="badge bg-dark">Full Access</span></td>
                                                    <td>3</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditRoleModal('Super Admin'))}><i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Super Admin', 'role'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Referee Manager</td>
                                                    <td>Manage referees & assignments</td>
                                                    <td><span className="badge bg-primary">Module-Specific</span></td>
                                                    <td>5</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditRoleModal('Referee Manager'))}><i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Referee Manager', 'role'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Finance Admin</td>
                                                    <td>Payouts & invoices</td>
                                                    <td><span className="badge bg-primary">Module-Specific</span></td>
                                                    <td>2</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditRoleModal('Finance Admin'))}><i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Finance Admin', 'role'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Club Coordinator</td>
                                                    <td>Club & team management</td>
                                                    <td><span className="badge bg-secondary">Read-Only</span></td>
                                                    <td>12</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditRoleModal('Club Coordinator'))}><i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Club Coordinator', 'role'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Guest Auditor</td>
                                                    <td>View reports only</td>
                                                    <td><span className="badge bg-secondary">Read-Only</span></td>
                                                    <td>1</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditRoleModal('Guest Auditor'))}><i className="bx bx-edit" data-bs-toggle="tooltip" title="Edit" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Guest Auditor', 'role'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="usersView" role="tabpanel" aria-labelledby="users-tab">
                                    <div className="entries-wrapper mb-3 home-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <button type="button" className="btn btn-primary d-flex align-items-center create-btn" onClick={openInviteUserModal}><i className="bx bx-plus me-2" />Create</button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered" id="table2" ref={table2}>
                                            <thead>
                                                <tr>
                                                    <th>User Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Role Assigned</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Alex Morgan</td>
                                                    <td>a.morgan@Sporting complex panel.com</td>
                                                    <td>+1 202-555-0173</td>
                                                    <td>Super Admin</td>
                                                    <td><span className="badge bg-success">Active</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditUserRoleModal('Alex Morgan'))}><i className="bx bx-edit" title="Edit Role" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openBlockModal('Alex Morgan'))}><i className="bx bx-block" title="Block" data-bs-toggle="tooltip" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Alex Morgan', 'user'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Jamie Lee</td>
                                                    <td>j.lee@Sporting complex panel.com</td>
                                                    <td>+1 305-555-0192</td>
                                                    <td>Referee Manager</td>
                                                    <td><span className="badge bg-success">Active</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditUserRoleModal('Jamie Lee'))}><i className="bx bx-edit" title="Edit Role" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openBlockModal('Jamie Lee'))}><i className="bx bx-block" title="Block" data-bs-toggle="tooltip" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Jamie Lee', 'user'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Taylor Smith</td>
                                                    <td>t.smith@Sporting complex panel.com</td>
                                                    <td>+1 415-555-0145</td>
                                                    <td>Finance Admin</td>
                                                    <td><span className="badge bg-warning text-dark">Invited</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditUserRoleModal('Taylor Smith'))}><i className="bx bx-edit" title="Edit Role" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openBlockModal('Taylor Smith'))}><i className="bx bx-block" title="Block" data-bs-toggle="tooltip" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Taylor Smith', 'user'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Jordan Rivera</td>
                                                    <td>j.rivera@Sporting complex panel.com</td>
                                                    <td>+1 718-555-0034</td>
                                                    <td>Club Coordinator</td>
                                                    <td><span className="badge bg-danger">Blocked</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditUserRoleModal('Jordan Rivera'))}><i className="bx bx-edit" title="Edit Role" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openBlockModal('Jordan Rivera'))}><i className="bx bx-block" title="Block" data-bs-toggle="tooltip" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Jordan Rivera', 'user'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Casey Park</td>
                                                    <td>c.park@Sporting complex panel.com</td>
                                                    <td>+1 210-555-0112</td>
                                                    <td>Guest Auditor</td>
                                                    <td><span className="badge bg-success">Active</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openEditUserRoleModal('Casey Park'))}><i className="bx bx-edit" title="Edit Role" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openBlockModal('Casey Park'))}><i className="bx bx-block" title="Block" data-bs-toggle="tooltip" /></a></li>
                                                            <li><a href="#" onClick={(e) => handleLinkClick(e, () => openDeleteModal('Casey Park', 'user'))}><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* New Role Modal */}
            {showNewRoleModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Create new role</h5>
                                <button type="button" className="btn-close" onClick={closeNewRoleModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="create_noti_form">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="col-md-12">
                                            <label className="form-label">Role name</label>
                                            <input type="text" className="form-control" id="roleName" />
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <label className="form-label">Rights</label>
                                            <div className="right-list">
                                                <ul>
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Dashboard</span>
                                                        <div className={`row switch-main ${activeRoles['Dashboard'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Dashboard']}
                                                                        onChange={() => toggleRole('Dashboard')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="dashboard_view" disabled={!activeRoles['Dashboard']} />
                                                                        <label htmlFor="dashboard_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="dashboard_delete" disabled={!activeRoles['Dashboard']} />
                                                                        <label htmlFor="dashboard_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Referee Management */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Referee Management</span>
                                                        <div className={`row switch-main ${activeRoles['Referee Management'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Referee Management']}
                                                                        onChange={() => toggleRole('Referee Management')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="referee_view" disabled={!activeRoles['Referee Management']} />
                                                                        <label htmlFor="referee_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="referee_send" disabled={!activeRoles['Referee Management']} />
                                                                        <label htmlFor="referee_send">Send</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Club Management */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Club Management</span>
                                                        <div className={`row switch-main ${activeRoles['Club Management'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Club Management']}
                                                                        onChange={() => toggleRole('Club Management')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="club_view" disabled={!activeRoles['Club Management']} />
                                                                        <label htmlFor="club_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="club_reschedule" disabled={!activeRoles['Club Management']} />
                                                                        <label htmlFor="club_reschedule">Reschedule</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="club_delete" disabled={!activeRoles['Club Management']} />
                                                                        <label htmlFor="club_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Game Matchmaking */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Game Matchmaking</span>
                                                        <div className={`row switch-main ${activeRoles['Game Matchmaking'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Game Matchmaking']}
                                                                        onChange={() => toggleRole('Game Matchmaking')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="matchmaking_view" disabled={!activeRoles['Game Matchmaking']} />
                                                                        <label htmlFor="matchmaking_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="matchmaking_edit" disabled={!activeRoles['Game Matchmaking']} />
                                                                        <label htmlFor="matchmaking_edit">Edit</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="matchmaking_delete" disabled={!activeRoles['Game Matchmaking']} />
                                                                        <label htmlFor="matchmaking_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Finances & Payouts */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Finances & Payouts</span>
                                                        <div className={`row switch-main ${activeRoles['Finances & Payouts'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Finances & Payouts']}
                                                                        onChange={() => toggleRole('Finances & Payouts')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="finance_view" disabled={!activeRoles['Finances & Payouts']} />
                                                                        <label htmlFor="finance_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="finance_download" disabled={!activeRoles['Finances & Payouts']} />
                                                                        <label htmlFor="finance_download">Download</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Roles Management */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Roles Management</span>
                                                        <div className={`row switch-main ${activeRoles['Roles Management'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Roles Management']}
                                                                        onChange={() => toggleRole('Roles Management')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="roles_view" disabled={!activeRoles['Roles Management']} />
                                                                        <label htmlFor="roles_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="roles_edit" disabled={!activeRoles['Roles Management']} />
                                                                        <label htmlFor="roles_edit">Edit</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="roles_delete" disabled={!activeRoles['Roles Management']} />
                                                                        <label htmlFor="roles_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Notifications */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Notifications</span>
                                                        <div className={`row switch-main ${activeRoles['Notifications'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Notifications']}
                                                                        onChange={() => toggleRole('Notifications')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="notifications_view" disabled={!activeRoles['Notifications']} />
                                                                        <label htmlFor="notifications_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="notifications_edit" disabled={!activeRoles['Notifications']} />
                                                                        <label htmlFor="notifications_edit">Edit</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="notifications_send" disabled={!activeRoles['Notifications']} />
                                                                        <label htmlFor="notifications_send">Send</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="notifications_delete" disabled={!activeRoles['Notifications']} />
                                                                        <label htmlFor="notifications_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Settings */}
                                                    <li style={{ marginBottom: '15px', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Settings</span>
                                                        <div className={`row switch-main ${activeRoles['Settings'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Settings']}
                                                                        onChange={() => toggleRole('Settings')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="settings_view" disabled={!activeRoles['Settings']} />
                                                                        <label htmlFor="settings_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="settings_edit" disabled={!activeRoles['Settings']} />
                                                                        <label htmlFor="settings_edit">Edit</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    {/* Profile */}
                                                    <li style={{ marginBottom: '15px', paddingBottom: '15px' }}>
                                                        <span className="list-switch">Profile</span>
                                                        <div className={`row switch-main ${activeRoles['Profile'] ? 'active' : ''}`}>
                                                            <div className="col-lg-3 col-md-3">
                                                                <label className="switch">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={activeRoles['Profile']}
                                                                        onChange={() => toggleRole('Profile')}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9">
                                                                <div className="check-role" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="profile_view" disabled={!activeRoles['Profile']} />
                                                                        <label htmlFor="profile_view">View</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="profile_edit" disabled={!activeRoles['Profile']} />
                                                                        <label htmlFor="profile_edit">Edit</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="profile_send" disabled={!activeRoles['Profile']} />
                                                                        <label htmlFor="profile_send">Send</label>
                                                                    </div>
                                                                    <div className="form-group1">
                                                                        <input type="checkbox" id="profile_delete" disabled={!activeRoles['Profile']} />
                                                                        <label htmlFor="profile_delete">Delete</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeNewRoleModal}>Cancel</button>
                                <button type="button" className="btn btn-primary" onClick={saveRole}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Role Modal */}
            {showEditRoleModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Role</h5>
                                <button type="button" className="btn-close" onClick={closeEditRoleModal}></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Role Name</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" defaultValue={selectedItem} placeholder="Enter role name" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Primary Responsibility</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" placeholder="Enter responsibility" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Access Level</label>
                                        <div className="col-md-9">
                                            <select className="form-select">
                                                <option value="full">Full Access</option>
                                                <option value="module">Module-Specific</option>
                                                <option value="read">Read-Only</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeEditRoleModal}>Close</button>
                                <button className="btn btn-primary" onClick={updateRole}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Invite User Modal */}
            {showInviteUserModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Invite New Staff</h5>
                                <button className="btn-close" onClick={closeInviteUserModal}></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">User Name</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" placeholder="Enter full name" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Email</label>
                                        <div className="col-md-9">
                                            <input type="email" className="form-control" placeholder="Enter email address" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Phone Number</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" placeholder="Enter phone number" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Role Assigned</label>
                                        <div className="col-md-9">
                                            <select className="form-select">
                                                <option value="">Select role</option>
                                                <option value="admin">Admin</option>
                                                <option value="editor">Editor</option>
                                                <option value="viewer">Viewer</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeInviteUserModal}>Cancel</button>
                                <button className="btn btn-primary" onClick={sendInvite}>Send Invite</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit User Role Modal */}
            {showEditUserRoleModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit User Details</h5>
                                <button type="button" className="btn-close" onClick={closeEditUserRoleModal}></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">User Name</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" defaultValue={selectedItem} placeholder="Enter full name" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Email</label>
                                        <div className="col-md-9">
                                            <input type="email" className="form-control" placeholder="Enter email" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Phone Number</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" placeholder="Enter phone number" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Role Assigned</label>
                                        <div className="col-md-9">
                                            <input type="text" className="form-control" placeholder="Enter role" />
                                        </div>
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <label className="col-md-3 col-form-label">Status</label>
                                        <div className="col-md-9">
                                            <select className="form-select">
                                                <option value="active">Active</option>
                                                <option value="invited">Invited</option>
                                                <option value="blocked">Blocked</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeEditUserRoleModal}>Close</button>
                                <button className="btn btn-primary" onClick={updateUser}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" onClick={closeDeleteModal}></button>
                            </div>
                            <div className="modal-body">
                                <h5>Are you sure you want to delete this {selectedType}?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Yes</button>
                                <button type="button" className="btn btn-secondary" onClick={closeDeleteModal}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Block Confirmation Modal */}
            {showBlockModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" onClick={closeBlockModal}></button>
                            </div>
                            <div className="modal-body">
                                <h5>Are you sure you want to block this user?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={confirmBlock}>Yes</button>
                                <button type="button" className="btn btn-secondary" onClick={closeBlockModal}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RolesManagement